module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp12_5.9950d720.png";